module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABRQAAAATCAMAAADWBXHFAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAtUExURUdwTOamX+amX+amX+amX+amX+amX+amX+GmReamX/////jm0eqzdf338fHMomTmjyYAAAAIdFJOUwBK8pcZe74L9MH+ngAAANFJREFUeNrt29tKxDAUhtFJj2a36fs/rkekWEGMUGC7FjCQ2x/4CGH6eIL71C5240YPEyCKIIqIIogiogg/RhHuMJVxqH8wjGWyIpDJOvc3cVREIJ/S28TZdkBGnXfF0XJASlNfFIvlgJTWa/D2rW17rUdrx+fhq9VyQE7X4G0RsdU9ImL/OFzYDfg3UWwR0eoREXG8HUIUATdFN0VAFN/fFOP8phjfvSnaDUiq66uWwW5AUktPFBe7AUkVf1MEOJl94wdwvisuv3pXHBb3RO71DO39wKiO6w/DAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/Home/expand.png
// module id = 563
// module chunks = 0